var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('tr',[_c('td',[(_vm.item && _vm.item.mid)?_c('span'):_c('span',[_vm._v(_vm._s(_vm.time))])]),_c('td',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }